import { render, staticRenderFns } from "./BaseComments.vue?vue&type=template&id=3f30ed20&scoped=true&"
import script from "./BaseComments.vue?vue&type=script&lang=ts&"
export * from "./BaseComments.vue?vue&type=script&lang=ts&"
import style0 from "./BaseComments.vue?vue&type=style&index=0&id=3f30ed20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30ed20",
  null
  
)

export default component.exports